<template>
  <div class="fatcher" >
    <div class="header">
      <div class="content" style="height: 500px;width: 120%;">
        <div class="left" v-if="!forgetPassword">
          <img src="@/assets/login-left.png" style="height: 500px;"/>
        </div>
         <div id="userLayout" :class="['user-layout-wrapper', device]">
        <div class="container">
          <div class="top">
            <div class="header">
              <a href="/">
    <!--            <img src="~@/assets/2.svg" class="logo" alt="logo">-->
                <span class="title">{{this.$store.getters.language['common.WelcomeTo']+" "+this.$store.getters.application.applicationNameLanguage?this.$store.getters.application.applicationNameLanguage:this.$store.getters.application.applicationName}}</span><!--{{this.$store.getters.language['home.message']}}-->
              </a>
            </div>
            <div class="desc">
            </div>
          </div>

          <route-view></route-view>


        </div>
      </div>
        </div>
    </div>
    <div class="footer">
      <!--<div class="links">
        <a href="http://doc.jeecg.com" target="_blank">帮助</a>
        <a href="https://github.com/zhangdaiscott/jeecg-boot" target="_blank">隐私</a>
        <a href="https://github.com/zhangdaiscott/jeecg-boot/blob/master/LICENSE" target="_blank">条款</a>
      </div>-->
      <div class="copyright">
        <!-- {{language['portal.ui2.browserTip']}}<br/> --> <!--本网站建议使用 Chrome,Firefox,IE11(含)以上版本浏览器-->
        Copyright © {{language['common.copyright.year']}} {{language['portal.ui2.copyright']}} <br/> <!--鴻海精密工業股份有限公司--> 
        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery"  style="padding-left: 5px;">{{language['common.copyright.filing']}}</a><br/> <!--粤ICP备13021698号-->
        {{ language['portal.ui2.contactEmail'] }}: xiao-jun.ding@foxconn.com
      </div>
    </div>
  </div>
</template>

<script>
  import RouteView from "@/components/layouts/RouteView"
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    name: "UserLayout",
    components: { RouteView },
    mixins: [mixinDevice],
    data () {
      return {
        forgetPassword: false
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    watch: {
      $route: function() {
        this.forgetPassword = false
        if (this.$route.query.type) this.forgetPassword = true
      }
    },
    created() {
    },
    mounted () {
      document.body.classList.add('userLayout')
    },
    beforeDestroy () {
      document.body.classList.remove('userLayout')
    },
  }
</script>

<style lang="less" scoped>

  .fatcher{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .left > img {
      /*width: 100%;
      height: 100%;*/
      object-fit: cover;
    }
  }

  .fatcher > .header{
    width: 100%;
    height: 100%;
    max-width: 1200px;
    min-height: 535px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 64px;
  }

  .content{
    width: 80%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .left{
   // border: 1px solid #00ff48;
    height: 100%;
  }


/deep/ .ant-tabs-bar {
  display: none;
}

  #userLayout.user-layout-wrapper {
    height: 100%;
    width: 60%;

    .container {
      width: 100%;
      height: 100%;
      //min-height: 100%;
      background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
      background-size: 100%;
      //padding: 110px 0 144px;
      padding: 64px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 24px;
            color: rgba(0, 0, 0, .85);
            font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 20px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        /*width: 376px;*/
        margin: 0 auto;
      }


    }
  }
  .footer {
    // position: absolute;
    width: 100%;
    // bottom: 0;
    padding: 0 16px;
    margin: 24px 0;
    text-align: center;

    .links {
      margin-bottom: 8px;
      font-size: 14px;
      a {
        color: rgba(0, 0, 0, 0.45);
        transition: all 0.3s;
        &:not(:last-child) {
          margin-right: 40px;
        }
      }
    }
    .copyright {
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
    }
  }
</style>